export default function number (number) {
    return parseFloat(number).toLocaleString('es-MX', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    })
};